import React from 'react'
import { Box, TableCell, TableRow, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { FileType, OpenNewTaskAttachmentTC } from './newTaskAttachments-reducer';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import PhotoSizeSelectActualTwoToneIcon from '@mui/icons-material/PhotoSizeSelectActualTwoTone';
import { AlertDialog } from '../common/AlertDialog';
import { OpenAttachment } from '../common/OpenAttachment';
import { AppRootState } from '../../app/store';

type AttachedItemPropsType = {
  file: FileType
  projectId: number
}

export const NewTaskAttachedItem = (props: AttachedItemPropsType) => {
  const dispatch = useDispatch()
  const arr = props.file.fileName.split('.')
  const fileType: string = arr[arr.length - 1]
  const currentAttachedUrl = useSelector<AppRootState, string>(state => state.newTaskAttachments.currentAttachmentUrl)
  // const currentAttachedType = useSelector<AppRootState, string>(state => state.workItems.currentAttachmentType)

  const downloadAttachment = (url: string) => {
    const linkUrl = document.createElement('a')
    linkUrl.download = url
    linkUrl.href = url
    document.body.appendChild(linkUrl)
    linkUrl.click()
    document.body.removeChild(linkUrl)
    linkUrl.remove()
  }
  const removeAttachmentFromNewTask = () => {

  }
  const openFile = () => {
    dispatch(OpenNewTaskAttachmentTC({ projectId: props.projectId, url: props.file.url, fileName: props.file.fileName}))
  }
  const closeFile = () => {

  }

  return (
    <TableRow hover>
      <TableCell>
        <Box sx={{ alignItems: 'center', display: 'flex' }}>
          <Typography >
            {props.file.fileName.includes('.jpg') || props.file.fileName.includes('.jpeg') || props.file.fileName.includes('.png')
              || props.file.fileName.includes('.bmp') || props.file.fileName.includes('.gif')
              ? <PhotoSizeSelectActualTwoToneIcon /> : <DescriptionOutlinedIcon />
            }
          </Typography>
          <OpenAttachment downloadAttachment={downloadAttachment} removeAttachment={removeAttachmentFromNewTask}
            name={props.file.fileName} openFile={openFile} closeFile={closeFile}
            currentAttachedUrl={props.file.url} currentAttachedType={fileType} />
        </Box>
      </TableCell>
      <TableCell >
        <Box sx={{ alignItems: 'center', display: 'flex' }}>
          <Typography variant="body1">
            {Math.round(props.file.size / 1024)}K
          </Typography>
        </Box>
      </TableCell>
      <TableCell style={{ textAlign: 'center' }}>
        <Typography>
          {moment(props.file.createdDate).locale('de').format('DD.MM.YYYY')}
        </Typography>
      </TableCell>
      <TableCell style={{ textAlign: 'center' }}>
        <AlertDialog fileName={props.file.fileName} removeAttachment={removeAttachmentFromNewTask} />
      </TableCell>
    </TableRow>
  )
}